import { Component, input, output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsTarget } from '@fcom/core-api';

@Component({
  selector: 'fin-text-link',
  templateUrl: './text-link.component.html',
  standalone: false,
})
export class TextLinkComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  teaserTitle = input<string>();
  target = input<CmsTarget>();
  colorClass = input<string>();

  linkClick = output<void>();
}
